import { render } from "./MesContactsView.vue?vue&type=template&id=24ff80a5"
import script from "./MesContactsView.vue?vue&type=script&lang=js"
export * from "./MesContactsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__